import { render, staticRenderFns } from "./CommunityQnaReply.vue?vue&type=template&id=19d490fe&"
import script from "./CommunityQnaReply.vue?vue&type=script&lang=js&"
export * from "./CommunityQnaReply.vue?vue&type=script&lang=js&"
import style0 from "./CommunityQnaReply.vue?vue&type=style&index=0&id=19d490fe&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports